/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriggerKind } from './trigger-kind';
import {
    TriggerKindFromJSON,
    TriggerKindFromJSONTyped,
    TriggerKindToJSON,
    TriggerKindToJSONTyped,
} from './trigger-kind';
import type { WorkflowAction } from './workflow-action';
import {
    WorkflowActionFromJSON,
    WorkflowActionFromJSONTyped,
    WorkflowActionToJSON,
    WorkflowActionToJSONTyped,
} from './workflow-action';

/**
 * 
 * @export
 * @interface MessageAddedToConversationTrigger
 */
export interface MessageAddedToConversationTrigger {
    /**
     * Discriminator property to identify the trigger type
     * @type {TriggerKind}
     * @memberof MessageAddedToConversationTrigger
     */
    kind: TriggerKind;
    /**
     * Action to be executed when trigger happens.
     * @type {WorkflowAction}
     * @memberof MessageAddedToConversationTrigger
     */
    action: WorkflowAction | null;
    /**
     * The sequence of the message in the conversation that should trigger the workflow.
     * @type {number}
     * @memberof MessageAddedToConversationTrigger
     */
    messageSequence: number;
    /**
     * The participant kind of the message that should trigger the workflow. When missing, the workflow will be executed regardless of the participant kind
     * @type {string}
     * @memberof MessageAddedToConversationTrigger
     */
    participantKind?: string | null;
}



/**
 * Check if a given object implements the MessageAddedToConversationTrigger interface.
 */
export function instanceOfMessageAddedToConversationTrigger(value: object): value is MessageAddedToConversationTrigger {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('messageSequence' in value) || value['messageSequence'] === undefined) return false;
    return true;
}

export function MessageAddedToConversationTriggerFromJSON(json: any): MessageAddedToConversationTrigger {
    return MessageAddedToConversationTriggerFromJSONTyped(json, false);
}

export function MessageAddedToConversationTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageAddedToConversationTrigger {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': TriggerKindFromJSON(json['kind']),
        'action': WorkflowActionFromJSON(json['action']),
        'messageSequence': json['message_sequence'],
        'participantKind': json['participant_kind'] == null ? undefined : json['participant_kind'],
    };
}

export function MessageAddedToConversationTriggerToJSON(json: any): MessageAddedToConversationTrigger {
    return MessageAddedToConversationTriggerToJSONTyped(json, false);
}

export function MessageAddedToConversationTriggerToJSONTyped(value?: MessageAddedToConversationTrigger | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': TriggerKindToJSON(value['kind']),
        'action': WorkflowActionToJSON(value['action']),
        'message_sequence': value['messageSequence'],
        'participant_kind': value['participantKind'],
    };
}

